__turbopack_context__.v({
  "afterRail": "DEYPNa_afterRail",
  "bar": "DEYPNa_bar",
  "barButton": "DEYPNa_barButton",
  "barHalf": "DEYPNa_barHalf",
  "barTitle": "DEYPNa_barTitle",
  "barWide": "DEYPNa_barWide",
  "beforeRail": "DEYPNa_beforeRail",
  "body": "DEYPNa_body",
  "column": "DEYPNa_column",
  "columnDivided": "DEYPNa_columnDivided",
  "dates": "DEYPNa_dates",
  "departureSkeleton": "DEYPNa_departureSkeleton",
  "departuresSkeleton": "DEYPNa_departuresSkeleton",
  "grid": "DEYPNa_grid",
  "packageSkeleton": "DEYPNa_packageSkeleton",
  "packageSkeletonLines": "DEYPNa_packageSkeletonLines",
  "packageSkeletonRow": "DEYPNa_packageSkeletonRow",
  "packages": "DEYPNa_packages",
  "packagesSkeleton": "DEYPNa_packagesSkeleton",
  "page": "DEYPNa_page",
  "pulse": "DEYPNa_pulse",
  "rail": "DEYPNa_rail",
  "rail-pin": "DEYPNa_rail-pin",
  "rail-slide-in": "DEYPNa_rail-slide-in",
  "railBrochure": "DEYPNa_railBrochure",
  "railSticky": "DEYPNa_railSticky",
  "sidebarError": "DEYPNa_sidebarError",
  "sidebarErrorText": "DEYPNa_sidebarErrorText",
  "sidebarErrorTitle": "DEYPNa_sidebarErrorTitle",
  "sidebarSkeleton": "DEYPNa_sidebarSkeleton",
  "trailing": "DEYPNa_trailing",
  "trailingGrid": "DEYPNa_trailingGrid",
});
